import React from 'react';
import PropTypes from 'prop-types';
import { renderToStaticMarkup } from 'react-dom/server';
import Modal from '../../../../../commonComponents/modal/Modal';
import {
  formatDate,
  formatNumbers,
  newFormatPrice,
} from '../../../../../services/utilityFunctions';
import translate from '../../../../../commonComponents/translate';
import ModalHeader from '../../../../../commonComponents/modal/ModalHeader';
import { BonusListItemType } from '../../../propTypes/bonusListItemDataProp';
import ServerSideList from '../../../../../commonComponents/lists/ServerSideList';
import UserColumn from '../../../../../commonComponents/lists/columns/UserColumn';

function BonusListDataItemBlockModal(props) {
  const { t, data, handleCloseModal } = props;
  const tableId = 'bonusListDataItemBlockModalList';

  if (!data) return null;

  const { type, sponsorId } = data;

  const makeListColumns = itemType => {
    const columns = [
      {
        field: 'user',
        title: t('name'),
        textAlign: 'left',
        width: 250,
        template: ({ user }) =>
          renderToStaticMarkup(
            <div>{user ? <UserColumn t={t} user={user} /> : '-'}</div>,
          ),
      },
      {
        field: 'email',
        title: t('email'),
        textAlign: 'left',
        width: 300,
        template: ({ user }) =>
          renderToStaticMarkup(<div>{user.email ? user.email : '-'}</div>),
      },
      {
        field: 'phone',
        title: t('phone'),
        textAlign: 'left',
        width: 100,
        template: ({ user }) =>
          renderToStaticMarkup(<div>{user.phone ? user.phone : '-'}</div>),
      },
    ];

    switch (itemType) {
      case BonusListItemType.STARTING_7D:
      case BonusListItemType.STARTING_30D:
        columns.push({
          field: 'VA',
          title: t('bonusListModal_body_VA'),
          textAlign: 'center',
          width: 60,
          template: ({ VA }) =>
            typeof VA === 'number' ? formatNumbers(VA, false, true) : '-',
        });
        columns.push({
          field: 'memberSince',
          title: t('bonusListModal_body_memberSince'),
          textAlign: 'center',
          width: 100,
          template: ({ memberSince }) =>
            renderToStaticMarkup(<>{formatDate(memberSince, 'DD/MM/YYYY')}</>),
        });
        columns.push({
          field: 'endDateBonus',
          title: t('bonusListModal_body_endDateBonus'),
          textAlign: 'center',
          width: 100,
          template: ({ endDateBonus }) =>
            renderToStaticMarkup(<>{formatDate(endDateBonus, 'DD/MM/YYYY')}</>),
        });
        break;
      case BonusListItemType.JACKPOT:
        columns.push({
          field: 'commission',
          title: t('bonusListModal_body_commission'),
          textAlign: 'center',
          width: 100,
          template: ({ commission, currencyInfo }) =>
            typeof commission === 'number'
              ? newFormatPrice(commission, true, currencyInfo.code)
              : ' - ',
        });
        break;
      case BonusListItemType.DESTINATION:
        columns.push({
          field: 'VA',
          title: t('bonusListModal_body_VA'),
          textAlign: 'center',
          width: 60,
          template: ({ VA }) =>
            typeof VA === 'number' ? formatNumbers(VA, false, true) : '-',
        });
        break;
      default:
        return [];
    }

    return columns;
  };

  const renderModalList = () => {
    let dataUrl = '/table/tailor-made/pureliink/report';
    let columns;

    switch (type) {
      case BonusListItemType.STARTING_7D:
        dataUrl += `/starting/7d/${sponsorId}/referral/list`;
        columns = makeListColumns(type);
        break;
      case BonusListItemType.STARTING_30D:
        dataUrl += `/starting/30d/${sponsorId}/referral/list`;
        columns = makeListColumns(type);
        break;
      case BonusListItemType.JACKPOT:
        dataUrl += `/jackpot/${sponsorId}/referral/list`;
        columns = makeListColumns(type);
        break;
      case BonusListItemType.DESTINATION:
        dataUrl += `/destination/${sponsorId}/referral/list`;
        columns = makeListColumns(type);
        break;
      default:
        return null;
    }

    return (
      <ServerSideList
        query={{}}
        id={tableId}
        columns={columns}
        dataSourceURL={dataUrl}
        defaultPageSize={10}
      />
    );
  };

  return (
    <Modal id="bonusListDataItemBlockModal" onClose={handleCloseModal}>
      <div
        className="modal-dialog modal-dialog-centered modal-xl"
        role="document"
      >
        <div className="modal-content">
          <ModalHeader
            title={t(`bonusListModal_header_${type}`)}
            onClose={handleCloseModal}
          />
          <div className="modal-body">{renderModalList()}</div>
        </div>
      </div>
    </Modal>
  );
}

BonusListDataItemBlockModal.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.shape({
    type: PropTypes.string.isRequired,
    sponsorId: PropTypes.string.isRequired,
  }),
  handleCloseModal: PropTypes.func.isRequired,
};

BonusListDataItemBlockModal.defaultProps = {
  data: null,
};

export default translate(BonusListDataItemBlockModal);
